import { Reducer } from "redux";
import {
	BannerActionTypes,
	BannerNotificationActions
} from "../../Actions/BannerNotification/BannerNotificationActions";
import {
	BannerFeedMessage,
	BannerFeedActivity
} from "@/Contracts/Others/NotificationFeed";

export interface BannerNotificationState {
	readonly bannerFeedMessage: BannerFeedMessage | null;
	readonly bannerFeedActivity: BannerFeedActivity | null;
	readonly isOpen: boolean;
	readonly isLoading: boolean;
	readonly vendorPromotionBannerDismissed?: boolean;
	readonly isPaymentDueBannerOpen: boolean;
}

export const initialState: BannerNotificationState = {
	isOpen: false,
	isLoading: false,
	bannerFeedMessage: null,
	bannerFeedActivity: null,
	vendorPromotionBannerDismissed: false,
	isPaymentDueBannerOpen: false
};

export const BannerNotificationReducer: Reducer<
	BannerNotificationState,
	BannerNotificationActions
> = (
	state: BannerNotificationState = initialState,
	action: BannerNotificationActions
): BannerNotificationState => {
	switch (action.type) {
		case BannerActionTypes.SHOW_BANNER_LOADER: {
			return { ...state, isLoading: true };
		}
		case BannerActionTypes.HIDE_BANNER_LOADER: {
			return { ...state, isLoading: false };
		}
		case BannerActionTypes.SHOW_BANNER: {
			return { ...state, isOpen: true };
		}
		case BannerActionTypes.HIDE_BANNER: {
			return { ...state, isOpen: false };
		}
		case BannerActionTypes.DISMISS_BANNER_REQUESTED: {
			return state;
		}
		case BannerActionTypes.DISMISS_BANNER_SUCCESSFUL: {
			return { ...state, isOpen: false };
		}
		case BannerActionTypes.DISMISS_BANNER_FAILED: {
			return state;
		}
		case BannerActionTypes.GET_BANNER_REQUESTED: {
			return state;
		}
		case BannerActionTypes.GET_BANNER_SUCCESSFUL: {
			return {
				...state,
				bannerFeedActivity: action.bannerFeedActivity,
				bannerFeedMessage: action.bannerFeedMessage,
				isOpen: !!action.bannerFeedMessage
			};
		}
		case BannerActionTypes.GET_BANNER_FAILED: {
			return state;
		}
		case BannerActionTypes.SUBSCRIBE_BANNER_REQUESTED: {
			return state;
		}
		case BannerActionTypes.SUBSCRIBE_BANNER_SUCCESSFUL: {
			return { ...state };
		}
		case BannerActionTypes.SUBSCRIBE_BANNER_FAILED: {
			return state;
		}
		case BannerActionTypes.TOGGLE_PAYMENT_DUE_BANNER: {
			return {
				...state,
				isPaymentDueBannerOpen: action.isPaymentDueBannerOpen
			};
		}
		default: {
			return state;
		}
	}
};

export default BannerNotificationReducer;
